import { Fragment } from "react";

export const InvalidReferenceId = ({ orderId }) => {
  return (
    <section className="checkoutOrder-section checkoutOrderSection">
      <div className="container-fluid container-lg">
        <div className="row">
          <div
            className="payaccount-empty text-center w-100 py-5 px-3"
            style={{ backgroundColor: "#fff", border: "none" }}
          >
            <svg
              width="72"
              height="72"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: 16 }}
            >
              <circle cx="12" cy="12" r="10" fill="#ffffff" stroke="rgb(131 130 130)" strokeWidth="1.5" />
              <line x1="12" y1="7" x2="12" y2="13" stroke="rgb(131 130 130)" strokeWidth="1.8" strokeLinecap="round" />
              <circle cx="12" cy="16.5" r="1.15" fill="rgb(131 130 130)" />
            </svg>
            <div className="payaccount-empty-text" style={{ color: "rgb(131 130 130)", fontSize: 18 }}>
              {orderId ? (
                <Fragment>
                  Given reference id <b># {orderId}</b> is invalid or does not exist.
                </Fragment>
              ) : (
                "Reference id is missing. Please check and try again."
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
